import { useMemo } from "react";

import { useAuth } from "./useAuth";
import { getActionKey } from "../utils/permissions";

// El usuario ADMIN legacy (el campo "role" simple, no el módulo Roles)
// que todavía no tiene ningún rol nuevo asignado funciona como
// respaldo temporal: así puede entrar al panel para crear el rol
// "Admin" con todos los permisos y asignárselo a sí mismo, sin
// quedarse bloqueado por el cambio. En cuanto tenga al menos un rol
// asignado, sus permisos pasan a depender por completo de esos roles,
// igual que cualquier otro usuario — deja de aplicar este respaldo.
export function usePermissions() {
  const { user } = useAuth();

  return useMemo(() => {
    const menuPermissions = Array.isArray(user?.menuPermissions)
      ? user.menuPermissions
      : [];
    const actionPermissions = Array.isArray(user?.actionPermissions)
      ? user.actionPermissions
      : [];
    const hasAnyRoleAssigned =
      Array.isArray(user?.roles) && user.roles.length > 0;

    const isLegacyAdminBootstrap =
      Boolean(user) && user.role === "ADMIN" && !hasAnyRoleAssigned;

    function hasMenuAccess(menuKey) {
      if (!user) {
        return false;
      }

      if (isLegacyAdminBootstrap) {
        return true;
      }

      return menuPermissions.includes(menuKey);
    }

    function hasAction(menuKey, actionCode) {
      if (!user) {
        return false;
      }

      if (isLegacyAdminBootstrap) {
        return true;
      }

      return actionPermissions.includes(getActionKey(menuKey, actionCode));
    }

    function hasAnyAccess() {
      if (!user) {
        return false;
      }

      if (isLegacyAdminBootstrap) {
        return true;
      }

      return menuPermissions.length > 0;
    }

    return {
      isLegacyAdminBootstrap,
      hasMenuAccess,
      hasAction,
      hasAnyAccess,
    };
  }, [user]);
}
